// Widget Service - API client for widget management

import api from './api';
import type { WidgetConfig, WidgetEmbedCode } from '../types/api';

export interface WidgetUpdateRequest {
  name?: string;
  description?: string | null;
  is_active?: boolean;
  allowed_domains?: string[];
  rate_limit_per_minute?: number;
  max_concurrent_sessions?: number;
  session_duration_hours?: number;
  conversation_retention_days?: number;
  custom_greeting?: string | null;
  theme_override?: Record<string, unknown> | null;
}

export const widgetService = {
  /**
   * Get all widget configurations
   */
  getWidgets: async (): Promise<WidgetConfig[]> => {
    const response = await api.get<WidgetConfig[]>('/widget/admin/configs');
    return response.data;
  },

  /**
   * Update a widget configuration
   */
  updateWidget: async (
    widgetId: string,
    updates: WidgetUpdateRequest
  ): Promise<WidgetConfig> => {
    const response = await api.patch<WidgetConfig>(
      `/widget/admin/configs/${widgetId}`,
      updates
    );
    return response.data;
  },

  /**
   * Get embed code for a specific widget
   */
  getEmbedCode: async (
    widgetId: string,
    position: 'bottom-right' | 'bottom-left' = 'bottom-right'
  ): Promise<WidgetEmbedCode> => {
    const response = await api.get<WidgetEmbedCode>(
      `/widget/${widgetId}/embed-code`,
      { params: { position } }
    );
    return response.data;
  },
};
